<template>
  <v-card rounded flat class="mt-8 pb-2 main">
    <div class="blackSvg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1280"
        height="461"
        viewBox="0 0 1280 461"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1280 40C1280 17.9086 1262.09 0 1240 0H40C17.9086 0 0 17.9086 0 40V293C0 315.091 17.9086 333 40 333H77C99.0914 333 117 350.909 117 373V421C117 443.091 134.909 461 157 461H1124C1146.09 461 1164 443.091 1164 421V373C1164 350.909 1181.91 333 1204 333H1240C1262.09 333 1280 315.091 1280 293V40Z"
          fill="black"
        />
      </svg>
    </div>
    <div
      :class="catchPhraseFontClass"
      class="text1 white--text"
      v-html="replaceColorMarkup(data.catchPhrase)"
    ></div>
    <div
      class="text2 white--text sigflo-bodyLarge"
      v-html="replaceColorMarkup(data.catchPhraseParagraph)"
    ></div>
    <div
      class="text3 white--text sigflo-h5"
      v-html="replaceColorMarkup(data.catchPhraseDetails)"
    ></div>
  </v-card>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    computed: {
      catchPhraseFontClass() {
        if (!this.data.catchPhrase) return 'sigflo-l';
        return this.data.catchPhrase.length > 60 ? 'sigflo-s' : 'sigflo-l';
      }
    }
  };
</script>

<style scoped>
  .main {
    width: 1280px;
    height: 461px;
    flex-shrink: 0;
  }
  .blackSvg {
    width: 1280px;
    height: 461px;

    margin-left: 80px;
    flex-shrink: 0;
    fill: var(--Black, #000);
  }
  .text1 {
    position: absolute;
    top: 40px;
    left: 150px;

    display: flex;
    width: 626px;
    flex-direction: column;
    justify-content: flex-end;
    flex-shrink: 0;
  }
  .text2 {
    position: absolute;
    top: 40px;
    right: 0px;

    display: flex;
    width: 372px;
    flex-direction: column;
    justify-content: flex-end;
    flex-shrink: 0;
  }
  .text3 {
    position: absolute;
    bottom: 30px;
    left: 270px;

    width: 947px;
  }
</style>
